import {Component, Injector} from "@angular/core";
import {AccountTypeSearchModel} from "../account-type-search.model";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {AccountTypeSearchPageComponent} from "../account-type-search-page/account-type-search-page.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-account-type-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(AccountTypeSearchModel),
        registerSearchControl(AccountTypeMultiSelectSearchControlComponent)
    ]
})
export class AccountTypeMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<AccountTypeSearchModel> {
    constructor(model: AccountTypeSearchModel, injector: Injector) {
        super(model, injector, "id", "name");
        this.extendedSearchComponent = AccountTypeSearchPageComponent;
    }
}
